import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@features/dashboard/services/dashboard.service';

@Component({
  selector: 'app-opportunity-insight',
  templateUrl: './opportunity-insight.component.html',
})
export class OpportunityInsightComponent implements OnInit {

  insight$ = this.dashboardService.getOpportunityInsight();

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

}
